import { ReactElement } from 'react';

import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { SxProps, Theme, Typography } from '@mui/material';

const NUGGET_STRINGS = appStrings.modules.nugget;

type NuggetEventProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        date: string;
      }
    | { type: 'LARGE' };
}>;

export const NuggetEvent = ({ variant }: NuggetEventProps): ReactElement => {
  if (variant.type === 'SMALL') {
    return (
      <Typography variant="body1" sx={bottomTextStyle}>
        <Typography fontWeight="bold">{NUGGET_STRINGS.eventSubtext}</Typography>
        {variant.date}
      </Typography>
    );
  }

  return <></>;
};

const bottomTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '20px',
  flexDirection: 'row',
  display: 'flex',
  mt: 3,
};
